import _Object$assign from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/object/assign";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/promise";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
import { env, util } from '@tencent/vft-common';
import moment from 'moment';
import InviteButton from './containers/InviteButton';
import Jackpot from './containers/Jackpot';
import EggInfo from './containers/EggInfo';
import NearestEgg from './containers/NearestEgg';
import MyRecord from './containers/MyRecord';
import EggMap from './containers/EggMap';
import Game from './containers/Game'; // import Seller from './containers/Seller'

import Leaderboard from './containers/Leaderboard';
import PengDanDialog from './containers/PengDanDialog/index.vue';
import StrategyPop from './containers/StrategyPop';
import Star from './containers/Star';
import wuji from './services/wuji';
import Gift from './containers/Gift';
import cookie from '@tencent/vft-common/cookie';
import service from './services/service';
import { throttle } from 'lodash-es';
export default {
  components: {
    StrategyPop: StrategyPop,
    InviteButton: InviteButton,
    Jackpot: Jackpot,
    EggInfo: EggInfo,
    NearestEgg: NearestEgg,
    MyRecord: MyRecord,
    EggMap: EggMap,
    // Seller,
    Leaderboard: Leaderboard,
    PengDanDialog: PengDanDialog,
    Star: Star,
    Gift: Gift,
    Game: Game
  },
  data: function data() {
    return {
      money: 0,
      shareCode: util.getUrlParam('shareCode'),
      banner: '//puui.qpic.cn/vupload/0/20190114_1547452624714_226j5cqhjjcj.png/0',
      showFloat: false,
      isGame: navigator.userAgent.toLowerCase().indexOf('msdk') >= 0,
      isWeibo: navigator.userAgent.toLowerCase().indexOf('weibo') >= 0,
      苹果规则: window.setting.苹果规则
    };
  },
  computed: _objectSpread({
    isPad: function isPad() {
      return env.isIpad || env.isApad;
    }
  }, mapState(['isLogin', 'loginStatus']), mapGetters(['userInfo', 'eggInfo', 'now', 'myShareCode', 'isOfficial', 'shareConfig']), {
    avatar: function avatar() {
      if (this.userInfo) {
        return this.userInfo.headurl;
      } else {
        return '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/imgs/common/head_default.svg';
      }
    },
    isYoo: function isYoo() {
      var _this = this;

      if (!this.eggInfo) {
        return false;
      }

      return [1, 3].some(function (item) {
        return item === _this.eggInfo['egg_type'];
      });
    },
    showGame: function showGame() {
      var nowDate = moment(this.now).format('YYYY-MM-DD');
      return window.setting.专场时间.filter(function (item) {
        return item.time === nowDate;
      });
    },
    bg: function bg() {
      var nowDate = moment(this.now).format('YYYY-MM-DD');
      var bgs = window.setting.背景图.filter(function (item) {
        return item.time === nowDate;
      });

      if (bgs && bgs.length) {
        return bgs[0].bg;
      } else {
        return '//puep.qpic.cn/vupload/0/20190126_1548513216611_1pamdumx721.jpeg/0';
      }
    }
  }),
  watch: {
    loginStatus: {
      immediate: true,
      handler: function handler(v) {
        var _this2 = this;

        if (v) {
          this.alert({
            title: '登录态异常，请重新登录',
            confirm: function confirm() {
              _this2._openLogin();
            }
          });
        }
      }
    }
  },
  methods: _objectSpread({}, mapActions(['getEggInfo', 'getMyShareCode', 'getLeaderboardInfo', 'getStatisticData', 'getEggList', 'getEggType']), {
    globlaHandler: function globlaHandler(e) {},
    comfirmLogin: function comfirmLogin() {
      var _this3 = this;

      var nick = util.getUrlParam('nick');
      return new _Promise(function (resolve, reject) {
        _this3.confirm({
          title: 'yoo视频账号:' + window.decodeURIComponent(nick),
          msg: '检测到当前账号和您yoo视频账不同，是否切换',
          confirmText: '切换账号',
          cancelText: '保留当前账号',
          confirm: function confirm() {
            _this3.$openLogin({
              title: '选择你要切换的帐号类型'
            });
          },
          cancel: function cancel() {
            resolve();
          }
        });
      });
    },
    getMoney: function () {
      var _getMoney = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return service.getMoney();

              case 2:
                res = _context.sent;

                if (res.ret === 0) {
                  this.money = res.leftBonus || 0;

                  if (this.money) {
                    this.money = this.money / 100;
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMoney() {
        return _getMoney.apply(this, arguments);
      }

      return getMoney;
    }(),
    moveHandler: function moveHandler() {
      var _scrollTop = window.document.body.scrollTop || document.documentElement.scrollTop;

      if (_scrollTop > 1000 && !this.showFloat) {
        this.showFloat = true;
      }

      if (_scrollTop <= 1000 && this.showFloat) {
        this.showFloat = false;
      }
    }
  }),
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var _this4 = this;

      var vuid, myVuid, res, banner;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              vuid = util.getUrlParam('vuid');
              myVuid = cookie.get('vuserid');

              if (!(myVuid && vuid && vuid !== myVuid && this.isLogin)) {
                _context2.next = 5;
                break;
              }

              _context2.next = 5;
              return this.comfirmLogin();

            case 5:
              _context2.prev = 5;
              _context2.next = 8;
              return wuji.getBanner();

            case 8:
              res = _context2.sent;

              if (res.code === 200) {
                banner = res.data.filter(function (item) {
                  return res._time <= item.valid_time;
                });
                banner = banner[0] || {};
                this.banner = banner.image || this.banner;
              }

              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](5);
              console.error(_context2.t0);

            case 15:
              if (this.now > moment(window.setting.活动结束时间)._d.getTime()) {
                this.alert({
                  title: '活动已结束',
                  msg: '去福利社看看吧，更多精彩内容等着你哦~',
                  confirm: function confirm() {
                    _this4.rootOpenUrl('//film.qq.com/x/welfare/');
                  }
                });
              } else if (this.now < moment(window.setting.活动开始时间)._d.getTime()) {
                this.alert({
                  title: '活动未开始',
                  msg: '去福利社看看吧，更多精彩内容等着你哦~',
                  confirm: function confirm() {
                    _this4.rootOpenUrl('//film.qq.com/x/welfare/');
                  }
                });
              }

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[5, 12]]);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var _this5 = this;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getEggType();

            case 2:
              this.getEggList();
              this.share.setShare(_Object$assign({}, this.shareConfig));

              if (!this.isLogin) {
                _context3.next = 8;
                break;
              }

              _context3.next = 7;
              return this.getMyShareCode();

            case 7:
              this.getMoney();

            case 8:
              _context3.next = 10;
              return this.getEggInfo();

            case 10:
              this.getStatisticData();
              _context3.next = 13;
              return this.getLeaderboardInfo();

            case 13:
              setTimeout(function () {
                _this5.$refs.myRecord.getMsg();
              }, 300);
              this.moveHandler();
              window.onscroll = throttle(function () {
                _this5.moveHandler();
              }, 50);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
};